import React from 'react';
import { Tooltip } from '@mui/material';

const tooltipSlotProps = {
  tooltip: { sx: { maxWidth: 300 } },
};

export default function PermissionDeniedWrapper({ show, title, placement = 'auto', fullWidth = false, children }) {
  if (!show || !title) {
    return children;
  }

  return (
    <Tooltip title={title} arrow placement={placement} slotProps={tooltipSlotProps}>
      <span
        style={{
          display: fullWidth ? 'flex' : 'inline-flex',
          ...(fullWidth ? { width: '100%' } : {}),
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
}
